import React from "react";
import SignInDialog from "../../molecules/signInDialog";
import LoadingOverlay from "../../molecules/loadingOverlay";
import ChangePassword from "../../organisms/ChangePassword";
import PropTypes from "prop-types";
import TellUsAboutYou from "../../organisms/TellUsAboutYou";
import TeamsCallingLocation from "../../organisms/TeamsCallingLocation";
import LoginPageStates from "../../../constants/loginpage-states";

const LoginPageTemplate = (props) => {
  const {
    errorDialog,
    loadingText,
    changePasswordComplete,
    tellAboutYouOnboardComplete,
    teamsCallingLocationComplete,
    contentToShow,
    ...signInDialogProps
  } = props;

  let content = null;

  switch (contentToShow) {
    case LoginPageStates.LOADING:
      content = <LoadingOverlay content={loadingText} />;
      break;
    case LoginPageStates.CHANGE_PASSWORD:
      content = (
        <ChangePassword changePasswordComplete={changePasswordComplete} />
      );
      break;
    case LoginPageStates.TELLUSABOUTYOU:
      content = (
        <TellUsAboutYou
          tellAboutYouOnboardComplete={tellAboutYouOnboardComplete}
        />
      );
      break;
    case LoginPageStates.TEAMSCALLINGLOCATION:
      content = (
        <TeamsCallingLocation
          teamsCallingLocationComplete={teamsCallingLocationComplete}
        />
      );
      break;
    case LoginPageStates.SIGNIN:
    default:
      content = <SignInDialog {...signInDialogProps} />;
      break;
  }

  return (
    <React.Fragment>
      {content}
      {errorDialog}
    </React.Fragment>
  );
};

LoginPageTemplate.propTypes = {
  loadingText: PropTypes.string,
  changePasswordComplete: PropTypes.func,
  tellAboutYouOnboardComplete: PropTypes.func,
  teamsCallingLocationComplete: PropTypes.func,
  contentToShow: PropTypes.number,
};

LoginPageTemplate.defaultProps = {
  contentToShow: LoginPageStates.SIGNIN,
};

export default LoginPageTemplate;
